import { ActionDispatching } from 'app/types-shared';
import { STATE } from 'app/constants';
import { isForbiddenStatus, blockAccess } from 'app/area/shared/actions-utils';
import { ErrorNotification, SuccessNotification } from 'app/infrastructure/notifications/user-messages';
import { defaultMaxResults, administrationMessagesTranslation } from '../constants';
import {
  RequestMessages, ReceiveMessages, FailMessages,
  RequestUpdateMessage, ReceiveUpdateMessage, FailUpdateMessage,
  ReceiveDeleteMessage,
  UpdateQuery, UpdateIncludeInactive
} from './action-types';
import { api } from './api';
import { AdministrationListMessage } from './types-store';

export const actionCreators = {

  loadMessages: (
    query: string,
    includeInactive: boolean,
    startIndex: number = 0,
    maxResults: number = defaultMaxResults
  ):
    ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {

      const clearList = startIndex === 0;
      dispatch(new RequestMessages(clearList));

      try {

        const messagesResponse = await api.loadMessages(
          query,
          includeInactive,
          startIndex,
          maxResults
        ) || {
          totalNumberOfResults: 0,
          results: []
        };

        const numberOfResults = messagesResponse.totalNumberOfResults;

        dispatch(new ReceiveMessages(messagesResponse.results, numberOfResults, clearList));

      } catch (err) {

        if (isForbiddenStatus(err)) {
          blockAccess({
            dispatch,
            getState,
            area: STATE.administrationMessages,
            translationId: administrationMessagesTranslation.no_access_to_message_administration
          });
        } else if (err && (err.userMessages || err.message)) {
          dispatch(new ErrorNotification(err.userMessages || err.message));
        }

        dispatch(new FailMessages());
      }
    },

  updateMessage: (
    id: number, 
    includeInactive: boolean,
    updatedMessage: Partial<AdministrationListMessage>,
    successMessage: string):
    ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {

      dispatch(new RequestUpdateMessage(id));

      try {

        const message = await api.updateMessage(id, updatedMessage);
        dispatch(new ReceiveUpdateMessage(id, includeInactive, message));
        !!successMessage && dispatch(new SuccessNotification(successMessage));

      } catch (err) {

        if (err && (err.userMessages || err.message)) {
          dispatch(new ErrorNotification(err.userMessages || err.message));
        }
        dispatch(new FailUpdateMessage(id));
      }
    },

  deleteMessage: (id: number, successMessage: string): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {

      dispatch(new RequestUpdateMessage(id));

      try {

        await api.deleteMessage(id);
        dispatch(new ReceiveDeleteMessage(id));
        dispatch(new SuccessNotification(successMessage));

      } catch (err) {

        if (err && (err.userMessages || err.message)) {
          dispatch(new ErrorNotification(err.userMessages || err.message));
        }
        dispatch(new FailUpdateMessage(id));
      }
    },

  updateQuery: (query: string): ActionDispatching<any, any> =>
    (dispatch: any, getState: any) => {
      dispatch(new UpdateQuery(query));
    },

  updateIncludeInactive: (includeInactive: boolean): ActionDispatching<any, any> =>
    (dispatch: any, getState: any) => {
      dispatch(new UpdateIncludeInactive(includeInactive));
    }
};
